@if (currentBooking$ | async; as booking) {
  @if (size === 'small') {
    <ion-card id="invite-users-to-stay-card" color="light">
      <ion-card-header>
        @if (booking.invitedGuests && booking.invitedGuests.length > 0) {
          <ion-card-title>
            {{
              'domain.property.modal.inviteUsers.invitedPeople.title'
                | transloco
            }}
            @if (size === 'small') {
              <ion-button
                fill="clear"
                color="primary"
                size="small"
                (click)="openInviteModal()"
              >
                <ion-icon
                  color="secondary"
                  slot="icon-only"
                  name="plus"
                ></ion-icon>
              </ion-button>
            }
          </ion-card-title>
        } @else {
          <ion-card-title>
            <h2 class="ion-no-margin">
              {{ 'domain.property.modal.inviteUsers.title' | transloco }}
            </h2>
          </ion-card-title>
          <ion-card-subtitle>
            <span
              style="
                opacity: 0.7;
                font-size: 16px;
                font-weight: 400;
                position: relative;
                top: 12px;
              "
            >
              {{
                'domain.property.modal.inviteUsers.description' | transloco
              }}</span
            >
          </ion-card-subtitle>
        }
      </ion-card-header>
      <ion-card-content>
        @if (booking.invitedGuests && booking.invitedGuests.length === 0) {
          <form [formGroup]="form">
            <ion-input
              formControlName="email"
              color="secondary"
              type="email"
              label="{{
                'domain.property.modal.inviteUsers.emailLabel' | transloco
              }}"
              label-placement="floating"
              fill="outline"
              placeholder="{{
                'domain.property.modal.inviteUsers.emailPlaceholder' | transloco
              }}"
              class="ion-margin-top"
            ></ion-input>
            @if (form.get('email')?.invalid && form.get('email')?.touched) {
              <ion-text color="danger" class="error-text">
                @if (form.get('email')?.errors?.['required']) {
                  <small>
                    {{ 'shared.label.requiredField' | transloco }}
                  </small>
                }
                @if (
                  form.get('email')?.errors?.['email'] &&
                  !form.get('email')?.errors?.['required']
                ) {
                  <small>
                    {{ 'shared.label.invalidEmail' | transloco }}
                  </small>
                }
              </ion-text>
            }
            <ion-button
              fill="solid"
              color="secondary"
              expand="block"
              (click)="onConfirm()"
              [disabled]="form.invalid || isLoading"
              class="ion-margin-top"
            >
              {{
                isLoading
                  ? ('domain.property.modal.inviteUsers.sending' | transloco)
                  : ('domain.property.modal.inviteUsers.sendInvite' | transloco)
              }}
            </ion-button>
          </form>
        }
        @if (booking.invitedGuests && booking.invitedGuests.length > 0) {
          <ion-list class="participants" lines="none">
            @for (
              guest of booking.invitedGuests;
              track guest.email;
              let isLast = $last
            ) {
              <ion-item [lines]="isLast ? 'none' : 'full'" transparent>
                <ion-avatar slot="start">
                  <img
                    src="https://ionicframework.com/docs/img/demos/avatar.svg"
                  />
                </ion-avatar>
                <ion-label>
                  <h5>
                    {{ guest?.firstName }} {{ guest?.lastName }}
                    <ion-badge
                      size="small"
                      color="secondary"
                      [ngClass]="{
                        accepted: guest?.verified,
                        pending: !guest?.verified
                      }"
                    >
                      @if (guest?.verified) {
                        {{
                          'domain.property.modal.inviteUsers.invitedPeople.status.accepted'
                            | transloco
                        }}
                      } @else {
                        {{
                          'domain.property.modal.inviteUsers.invitedPeople.status.pending'
                            | transloco
                        }}
                      }
                    </ion-badge>
                  </h5>
                  <p>{{ guest.email }}</p>
                </ion-label>
                <!-- <ion-button
                slot="end"
                fill="clear"
                color="danger"
                (click)="removeInvitation(guest.email)"
                >
                <ion-icon name="trash" slot="start"></ion-icon>
              </ion-button> -->
              </ion-item>
            }
          </ion-list>
        }
      </ion-card-content>
    </ion-card>
  } @else {
    <form [formGroup]="form" class="flex">
      <div class="flex flex-column flex-1 no-gap">
        <ion-input
          formControlName="email"
          type="email"
          label="{{
            'domain.property.modal.inviteUsers.emailLabel' | transloco
          }}"
          label-placement="floating"
          fill="outline"
          placeholder="{{
            'domain.property.modal.inviteUsers.emailPlaceholder' | transloco
          }}"
        ></ion-input>
        @if (form.get('email')?.invalid && form.get('email')?.touched) {
          <ion-text color="danger" class="error-text">
            @if (form.get('email')?.errors?.['required']) {
              <small>
                {{ 'shared.label.requiredField' | transloco }}
              </small>
            }
            @if (
              form.get('email')?.errors?.['email'] &&
              !form.get('email')?.errors?.['required']
            ) {
              <small>
                {{ 'shared.label.invalidEmail' | transloco }}
              </small>
            }
          </ion-text>
        }
      </div>
      <ion-button
        fill="solid"
        color="primary"
        expand="block"
        (click)="onConfirm()"
        [disabled]="form.invalid || isLoading"
        class="ion-no-margin"
      >
        {{
          isLoading
            ? ('domain.property.modal.inviteUsers.sending' | transloco)
            : ('domain.property.modal.inviteUsers.sendInvite' | transloco)
        }}
      </ion-button>
    </form>
    <ion-list class="participants ion-margin-top" lines="none">
      <ion-list-header>
        <ion-label>
          {{
            'domain.property.modal.inviteUsers.invitedPeople.title' | transloco
          }}
        </ion-label>
      </ion-list-header>
      @if (booking.invitedGuests && booking.invitedGuests.length > 0) {
        @for (
          guest of booking.invitedGuests;
          track guest.email;
          let isLast = $last
        ) {
          <ion-item [lines]="isLast ? 'none' : 'full'" transparent>
            <ion-avatar slot="start">
              <img src="https://ionicframework.com/docs/img/demos/avatar.svg" />
            </ion-avatar>
            <ion-label>
              <h5>
                {{ guest?.firstName }} {{ guest?.lastName }}
                <ion-badge
                  size="small"
                  color="secondary"
                  [ngClass]="{
                    accepted: guest?.verified,
                    pending: !guest?.verified
                  }"
                >
                  @if (guest?.verified) {
                    {{
                      'domain.property.modal.inviteUsers.invitedPeople.status.accepted'
                        | transloco
                    }}
                  } @else {
                    {{
                      'domain.property.modal.inviteUsers.invitedPeople.status.pending'
                        | transloco
                    }}
                  }
                </ion-badge>
              </h5>
              <p>{{ guest.email }}</p>
            </ion-label>
          </ion-item>
        }
      } @else {
        <ion-item>
          <ion-icon
            color="secondary"
            name="info-circle"
            slot="start"
          ></ion-icon>
          <ion-label>
            <h5>
              {{
                'domain.property.modal.inviteUsers.invitedPeople.noInvites.title'
                  | transloco
              }}
            </h5>
            <p>
              {{
                'domain.property.modal.inviteUsers.invitedPeople.noInvites.description'
                  | transloco
              }}
            </p>
          </ion-label>
        </ion-item>
      }
    </ion-list>
  }
}
